{
  "placeholder": "Veuillez saisir {fieldName}",
  "email": "E-mail",
  "validEmail": "L'e-mail doit être valide",
  "password": "Mot de passe",
  "validPassword": "Le mot de passe doit contenir au moins 8 caractères, dont 1 majuscule, 1 minuscule, 1 chiffre et 1 caractère spécial",
  "passwordsDontMatch": "Les mots de passe ne correspondent pas",
  "newPassword": "Nouveau mot de passe",
  "confirmPassword": "Confirmer le mot de passe",
  "confirmPasswordPlaceholder": "Veuillez confirmer le mot de passe",
  "confirmNewPassword": "Confirmer le nouveau mot de passe",
  "confirmNewPasswordPlaceholder": "Veuillez confirmer le nouveau mot de passe",
  "oldPassword": "Ancien mot de passe",
  "verificationCode": "Code de vérification",
  "validVerificationCode": "Le code de vérification doit comporter 6 chiffres",
  "verificationCodeRequired": "Le code de vérification est obligatoire",
  "name": "Prénom",
  "surname": "Nom",
  "telNumber": "Numéro de téléphone",
  "mobileNumber": "Numéro de mobile",
  "countryRegion": "Pays / Région",
  "validPhoneNumber": "Veuillez saisir un numéro de téléphone valide",
  "submit": "Envoyer",
  "update": "Mettre à jour",
  "submitVerificationCode": "Envoyer le code de vérification",
  "csvInvalid": "L'une de ces URL séparées par des virgules est invalide",
  "selectDatetime": "Sélectionner la date/l'heure",
  "asap": "Dès que possible",
  "selectAddress": "Sélectionner une adresse",
  "searchPostcodeOrAddress": "Rechercher un code postal ou une adresse",
  "filterNicknameOrAddress": "Filtrer par nom abrégé ou adresse",
  "searchFor": "Rechercher {label}",
  "select": "Sélectionner {label}",
  "toPayment": "Aller au paiement",
  "addressForm": {
    "addAddress": "Ajouter une adresse",
    "editAddress": "Modifier l'adresse",
    "labels": {
      "code": "Nom abrégé",
      "addressName": "Nom de l'entreprise/de l'adresse",
      "address1": "Adresse ligne 1",
      "address2": "Adresse ligne 2",
      "address3": "Ville",
      "address4": "Région",
      "postcode": "Code postal",
      "notes": "Notes"
    },
    "placeholders": {
      "code": "Exemple : Siège",
      "addressName": "Exemple : Exemple Solutions SARL",
      "address1": "Exemple : 123 rue de l'Exemple",
      "address2": "Exemple : Parc de l'Innovation",
      "address3": "Exemple : Paris",
      "address4": "Exemple : Île-de-France",
      "postcode": "Exemple : 75001",
      "notes": "Exemple : Adresse du bureau principal"
    },
    "useAsDefault": "Utiliser par défaut",
    "submitInsert": "Ajouter",
    "submitUpdate": "Mettre à jour",
    "deleteAddress": "Supprimer",
    "deleteAddressAlert": "Supprimer cette adresse ?",
    "insertSuccessToast": "Adresse ajoutée",
    "insertFailToast": "Impossible d'ajouter l'adresse",
    "editSuccessToast": "Adresse mise à jour",
    "editFailToast": "Impossible de mettre à jour l'adresse",
    "deleteSuccessToast": "Adresse supprimée",
    "deleteFailToast": "Impossible de supprimer l'adresse"
  },
  "format": "Format : {formats} | Formats : {formats}",
  "isRequired": "{fieldName} est obligatoire",
  "mustBeWholeNum": "{fieldName} doit être un nombre entier",
  "mustBeNum": "{fieldName} doit être un nombre",
  "mustBeTwoDecimalPlaces": "{fieldName} doit comporter au maximum 2 chiffres après la virgule",
  "equalTo": "Égal à",
  "equalGreaterThan": "Supérieur ou égal à",
  "equalLessThan": "Inférieur ou égal à",
  "greaterThan": "Supérieur à",
  "lessThan": "Inférieur à",
  "isNull": "Est vide",
  "isNotNull": "N'est pas vide",
  "isOneOf": "Fait partie de",
  "isNotOneOf": "Ne fait pas partie de",
  "between": "Entre",
  "contains": "Contient",
  "flightDate": "Date du vol",
  "flightNumber": "Numéro de vol",
  "holdOff": "Temps d'attente",
  "complete": "Compléter {section}",
  "sendConfirmation": {
    "submit": "Envoyer",
    "title": "Envoyer la confirmation",
    "otherEmail": "Autre e-mail",
    "emailErrorText": "Veuillez sélectionner ou saisir un e-mail valide"
  },
  "tariff": {
    "viewOnlyMessage": "Veuillez nous appeler pour réserver ce service",
    "unavailableMessage": "Veuillez sélectionner un service disponible",
    "unavailableRibbonMessage": "Appeler pour réserver",
    "bookMessage": "Réserver - {tariff}",
    "sortLabel": "Trier les tarifs par"
  },
  "stops": {
    "accordionHeader": "Détails",
    "asDirectedLabel": "Sur instruction",
    "missingAddressStopMessage": "Arrêt manquant"
  },
  "vouchers": {
    "vouchersAddedCount": "1 bon ajouté | {count} bons ajoutés",
    "maxVouchersMessage": "Vous pouvez ajouter au maximum {maxVouchers} bons",
    "addVoucherButton": "Ajouter un bon",
    "noVouchersMessage": "Aucun bon ajouté",
    "voucherNumber": "Bon n° {num}",
    "voucherCode": "Code : {voucherCode}",
    "enterVoucherCode": "Saisissez le code du bon"
  },
  "arriveByAwaitingDetailsMessage": "Complétez les détails de la réservation pour voir l'heure d'arrivée",
  "goodButtons": {
    "copy": "Copier {good}",
    "remove": "Supprimer {good}",
    "add": "Ajouter {good}"
  },
  "maxGoodsQtyMessage": "La quantité totale de toutes les marchandises ne peut pas dépasser {max}",
  "maxGoodsCartonsMessage": "Le nombre total de cartons de toutes les marchandises ne peut pas dépasser {max}",
  "quickQuoteBookingMessage": "Pour finaliser votre réservation, veuillez vous connecter à un compte {app} ou en créer un",
  "termsAndConditions": {
    "message": "En effectuant cette réservation, vous acceptez les",
    "link": "conditions générales de réservation",
    "afterMessage": ""
  },
  "cancelBooking": {
    "submit": "Annuler",
    "otherReason": "Autre motif",
    "message": "Veuillez indiquer un motif",
    "reasonErrorText": "Veuillez sélectionner ou saisir un motif d'annulation valide"
  }
}
